import React from "react";
import {Route} from "react-router-dom";

// const Seating = React.lazy(() => import("./Seating"));

const commerceInit = {
    reducers: {},
    routes: [
        // <Route key="commerce_seating" exact path="/commerce/seating/:id" element={<Seating />} />
    ],
    i18n: {
        en: {},
        ar: {}
    },
};

export default commerceInit;

